module.exports = __webpack_public_path__ + "img/certified-course.94ca9fba.jpg";